import { StateCreator } from 'zustand';
import { StoreSlices } from '.';

export interface FooterProps {
  isLastStep: boolean;
  isBundleSaveable: boolean;
  hasDynamicSize: boolean;
  size: number;
  basePrice: number;
  bundlePrice: number;
  discountedPrice: number;
}

export interface FooterSlice extends FooterProps {
  setPrices: (
    basePrice: number,
    bundlePrice: number,
    discountedPrice: number,
  ) => void;
  setIsBundleSaveable: (isSaveable: boolean) => void;
  setSizes: (size: number, hasDynamicSize: boolean) => void;
}

export const createFooterSlice =
  (
    initProps?: Partial<FooterProps>,
  ): StateCreator<
    Partial<StoreSlices>,
    [['zustand/devtools', never], ['zustand/immer', never]],
    [],
    FooterSlice
  > =>
  (set) => ({
    isLastStep: initProps?.isLastStep ?? false,
    isBundleSaveable: initProps?.isBundleSaveable ?? false,
    hasDynamicSize: initProps?.hasDynamicSize ?? false,
    size: initProps?.size ?? 0,
    basePrice: initProps?.basePrice ?? 0,
    bundlePrice: initProps?.bundlePrice ?? 0,
    discountedPrice: initProps?.discountedPrice ?? 0,
    setPrices: (basePrice, bundlePrice, discountedPrice) =>
      set(
        (state) => {
          state.footer.basePrice = basePrice;
          state.footer.bundlePrice = bundlePrice;
          state.footer.discountedPrice = discountedPrice;
        },
        undefined,
        'footer/setPrices',
      ),
    setIsBundleSaveable: (isSaveable) =>
      set(
        (state) => {
          state.footer.isBundleSaveable = isSaveable;
        },
        undefined,
        'footer/setIsBundleSaveable',
      ),
    setSizes: (size, hasDynamicSize) =>
      set(
        (state) => {
          state.footer.size = size;
          state.footer.hasDynamicSize = hasDynamicSize;
        },
        undefined,
        'footer/setSizes',
      ),
  });
